import { FaClasses } from "../../tools/css.tools";
import { createHtmlElement, htmlStringToElement } from "../../tools/dom.tools";

// TODO Create icon component, then delete this file
export type Icon = {

    /** Name of icon (ex fa-calendar, fa-plus, etc.) */
    name: string,

    /** 
     * Prefix of icon (ex fas, far, fad, ect.), 
     * @default "fas": FaClasses.SOLID (solid) 
     */
    prefix?: FaClasses,

    /** Optional classes to add to icon element */
    classes?: string[],

    /** Add "fa-fw" to fix icon width same as others */
    fixedWidth?: boolean,

    /** 
     * Used to generate custom icons with html stringified (ex: stackedIcons)
     * ! Will override others parameters
     */
    htmlString?: string
}

/** Build html element from Icon type */
export function buildIcon(icon: Icon): HTMLElement {
    let i: HTMLElement | undefined;
    if (icon.htmlString) {// Try building icon from string given
        i = htmlStringToElement(icon.htmlString);
    }
    if (!i) {
        const classes: string[] = [icon.prefix ?? FaClasses.SOLID];
        if (icon.name) { classes.push(icon.name); }
        if (icon.fixedWidth) { classes.push("fa-fw"); }
        if (icon.classes) { classes.push(...icon.classes); }

        i = createHtmlElement("i", {
            cssClass: classes.map(c => c.split(" ")).flat(),
            attributes: {
                ref: "icon",
                ariaHidden: "true"
            }
        });
    }
    return i;
}